import script from "./cc_submitters_autocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./cc_submitters_autocomplete.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__